;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('companyItem', companyItem)

  /* @ngInject */
  function companyItem () {
    return {
      restrict: 'E',
      scope: {
        company: '<'
      },
      templateUrl: '/core/directives/company-item/company-item-directive.html?$$REVISION$$',
      controller: 'CompanyItemController'
    }
  }
})()
